import { render, staticRenderFns } from "./layer-question-dialog.vue?vue&type=template&id=022c1205&scoped=true&"
import script from "./layer-question-dialog.vue?vue&type=script&lang=js&"
export * from "./layer-question-dialog.vue?vue&type=script&lang=js&"
import style0 from "./layer-question-dialog.vue?vue&type=style&index=0&id=022c1205&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c1205",
  null
  
)

export default component.exports